var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWashingMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17C19 18.6569 17.6569 20 16 20C14.3431 20 13 18.6569 13 17C13 15.3431 14.3431 14 16 14C17.6569 14 19 15.3431 19 17ZM18 17C18 18.1046 17.1046 19 16 19C14.8954 19 14 18.1046 14 17C14 15.8954 14.8954 15 16 15C17.1046 15 18 15.8954 18 17Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12C11 11.4477 11.4477 11 12 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H12C11.4477 13 11 12.5523 11 12Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11C16.2239 11 16 11.2239 16 11.5V12.5C16 12.7761 16.2239 13 16.5 13C16.7761 13 17 12.7761 17 12.5V11.5C17 11.2239 16.7761 11 16.5 11Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11C9 9.89543 9.89543 9 11 9H21C22.1046 9 23 9.89543 23 11V21C23 22.1046 22.1046 23 21 23H11C9.89543 23 9 22.1046 9 21V11ZM11 10H21C21.5523 10 22 10.4477 22 11V21C22 21.5523 21.5523 22 21 22H11C10.4477 22 10 21.5523 10 21V11C10 10.4477 10.4477 10 11 10Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachine);
export default __webpack_public_path__ + "static/media/washing_machine.a0f37a9802e20d0043fd5ad476683c0e.svg";
export { ForwardRef as ReactComponent };